// Truncado de etiquetas largas para celdas/pills angostas, con el mismo patrón
// del reporte financiero (EvolutionTableDataRow): se muestran unas pocas letras
// + "…" y el texto completo va en un tooltip (floating-vue `v-tooltip`).
export const ACCOUNT_LABEL_MAX = 24;

// Texto a mostrar: recortado con "…" si supera `max`, o intacto si no.
export function truncateLabel(text, max = ACCOUNT_LABEL_MAX) {
    if (!text) return text;
    return text.length > max ? text.substring(0, max) + "…" : text;
}

// Contenido del tooltip: el texto completo SÓLO cuando está recortado (string
// vacío = floating-vue no muestra tooltip), para no duplicar lo ya visible.
export function labelTooltip(text, max = ACCOUNT_LABEL_MAX) {
    return text && text.length > max ? text : "";
}
